import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'

class ImageUpload extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            bannerError: false,
            imageUrl: props.imageUrl,
        }
    }

    selectUploadFile = () => {
        this.imageInput.click()
    }

    upload = (e) => {
        const {
            store,
            onUpload,
            surveyId,
            type,
        } = this.props
        const file = e.target.files[0]
        const uploadType = type
        const allowedTypes = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png', 'image/svg+xml']
        const maxSize = 2 /** size in MB */
        const sizeMB = file.size / 1000 / 1000
        const oldBanner = this.state.imageUrl
        const url = URL.createObjectURL(file)
        const img = new Image()

        if (sizeMB > maxSize || allowedTypes.indexOf(file.type) === -1) {
            this.bannerError = true
        } else {
            this.bannerError = false
        }
        this.imageInput.value = ''
        if (!this.bannerError) {
            store.http.upload(`/survey/${surveyId}/banner?type=${uploadType}`, file, {
                fileName: file.name,
                prevFileName: oldBanner,
            }, store.surveyToken)
                .then((response) => {
                    console.log(response.bannerTag)
                    const stateCopy = { ...this.state }
                    stateCopy.imageUrl = response.bannerTag
                    img.onload = () => {
                        this.setState(stateCopy)
                        const width = img.width > 1140 ? 1140 : img.width
                        if (onUpload && typeof onUpload === 'function') {
                            onUpload({ fileName: response.bannerTag, type: uploadType, width })
                        }
                    }
                    img.src = url
                })
                .catch((error) => {
                    console.log(error)
                    store.handleError({ body: 'Failed to upload banner', level: 'error' })
                })
        }
    }

    removeBanner = () => {
        const { store, type, onUpload } = this.props
        const { survey } = store
        const stateCopy = { ...this.state }
        const oldBanner = stateCopy.imageUrl
        const uploadType = type
        store.http.delete(`/survey/${survey.id}/banner`, store.surveyToken, new Map([['fileName', oldBanner]]))
            .then((response) => {
                console.log(response)
            })
            .catch((e) => {
                console.log(e)
            })
        stateCopy.imageUrl = ''
        this.setState(stateCopy)
        if (onUpload && typeof onUpload === 'function') {
            onUpload({ fileName: '', type: uploadType })
        }
    }

    getImageUrl = () => {
        const { store } = this.props
        const baseUrl = `${store.http.cdnUrl}/images/survey/`
        return baseUrl + this.state.imageUrl
    }

    render() {
        const { disabled } = this.props
        return (
            <Fragment>
                <div className='imageUpload' onClick={this.selectUploadFile}>
                    <input data-type="banner" disabled={disabled} type="file" onChange={this.upload} ref={(input) => { this.imageInput = input }}/>

                    {!this.state.imageUrl
                        && (
                            <div className='imagePlaceholder'>
                                <i className='fal fa-circle-plus'/>

                                <p>{i18n.t('preview.uploadImage')}</p>
                            </div>
                        )}

                    {this.state.imageUrl
                        && (
                            <div style={{ alignSelf: 'center' }}>
                                <img src={this.getImageUrl()}/>
                            </div>
                        )}
                </div>

                {this.state.imageUrl
                    && (
                        <div onClick={this.removeBanner} className='removeImage'>{i18n.t('image.remove')}</div>
                    )}
            </Fragment>
        )
    }
}

export default ImageUpload
